import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// Get all Features
export const getFeatures = createAsyncThunk(
  "admin/allFeatures",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/feature/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Add Feature
export const addFeature = createAsyncThunk(
  "admin/addFeature",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/feature/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Edit Feature
export const editFeature = createAsyncThunk(
  "admin/editFeature",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/feature/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Get Single Feature
export const getSingleFeature = createAsyncThunk(
  "admin/singleFeature",
  async (featureId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/feature/${featureId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Delete Feature
export const deleteFeature = createAsyncThunk(
  "admin/deleteFeature",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/feature/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Initial State
const initialState = {
  featureData: [],
  singleFeatureData: [],
};

// Slice
const featureSlice = createSlice({
  name: "featureSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatures.fulfilled, (state, action) => {
      state.featureData = action.payload.data;
    });
    builder.addCase(getSingleFeature.fulfilled, (state, action) => {
      state.singleFeatureData = action.payload.data;
    });
  },
});

export default featureSlice.reducer;
